module.exports = __webpack_public_path__ + "84a788463becb0193b113f37df2cc51b.pdf";